import React from "react";
import img1 from "../../../Assets/ISO Certification/img1.png";
import img2 from "../../../Assets/ISO Certification/img2.png";
import img3 from "../../../Assets/ISO Certification/img3.png";

const ISOCertificationCost9001 = () => {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 p-10">
        {/* right side content  */}
        <div className="w-full text-[#032303] font-medium sm:text-3xl md:font-medium text-md lg:text-3xl xl:text-4xl">
          <h1 className="mb-3">
            <span className="border-b-4 border-[#249742]">ISO 90</span>
            01:2015 Certification Cost
          </h1>

          <div className="py-4 lg:py-8 space-y-2">
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              Get ISO Certificate at best possible low price from IS
              Consultancy. ISO Certification Cost Mainly Depends on following
              Factors –
            </p>

            <ol className="list-decimal ml-5 text-xs md:text-lg py-4 text-[#4D4D4D]">
              <li>
                Accreditation Board – IAF Members (International Accreditation
                Forum) Boards like: EIAC (Dubai), EGAC (Egypt), IAS (American),
                DAKKS (Germany), JAS ANZ (Australia) etc.
              </li>
              <li className="py-2">
                Certification Body. Bodies like: ROHS (EIAC), OTABU (EGAC), AAPL
                (IAS), MMS (EGAC), QRO (EGAC), DBS (IAS) etc.
              </li>
              <li>Independent Body/Board (NON-IAF).</li>
            </ol>
          </div>
        </div>

        {/* left side images  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex flex-col items-end gap-4 justify-end w-full">
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img1} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
            <div className="w-full lg:w-auto">
              {" "}
              <img src={img2} alt="" className="rounded-lg w-full lg:w-auto" />
            </div>
          </div>
          <div className="h-full">
            <img src={img3} alt="" className="rounded-lg h-full" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOCertificationCost9001;
